import { EditorEvent } from '@portal-core/project-files/events/editor-event.event';
import { NodeViewBase } from '@portal-core/text-editor/node-views/node-view.base';
import { GetPosForNodeView } from '@portal-core/text-editor/node-views/types/nodeview-get-pos.type';
import { BidiBridge } from '@portal-core/util/bidi-bridge';
import { Node } from 'prosemirror-model';
import { Decoration, EditorView, NodeView } from 'prosemirror-view';

/**
 * Renders a node with the given tag name.
 * Typically this is done in the NodeSpec but some cases require context that is not available in the NodeSpec.
 * For example, snippet node views render the html and body nodes as different tags so that the html and body styles are not applied to them.
 */
export class TagNameNodeView extends NodeViewBase implements NodeView {
  constructor(
    node: Node,
    editorView: EditorView,
    getPos: GetPosForNodeView,
    decorations: Decoration[],
    nodeViewBridge: BidiBridge<EditorEvent, EditorEvent>,
    editorTagName: string
  ) {
    super(node, editorView, getPos, decorations, nodeViewBridge, editorTagName);
    this.contentDOM = this.dom;
    this.syncNode(node);
  }
}
